import cellarsReducer from "./cellarsReducer"
export default cellarsReducer
